import { connect } from 'react-redux';

import FeatureFlags from './FeatureFlags';
import { actionCreators, selectors } from '../../../dux/user';

const mapStateToProps = (state) => ({
  user: selectors.getIdentityState(state),
});

const mapDispatchToProps = {
  getFlagsHandler: actionCreators.getFeatureFlags,
  unsubscribeHandler: actionCreators.unsubscribeFromFeatureFlags,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeatureFlags);
